export default "/images/vendor/flag-icon-css/flags/1x1/je.svg?e1bb30f3c6be27ba0bc425574ed802bb";